function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/node_modules/react-event-listener/node_modules/@babel/runtime/helpers/setPrototypeOf.js
// module id = 2100
// module chunks = 0